module.exports = __webpack_public_path__ + "img/one_platform.050e4ba9.png";